// extracted by mini-css-extract-plugin
export var graphic = "HowWeDoIt-module--graphic--14_dJ";
export var svg = "HowWeDoIt-module--svg--1I8wm";
export var circle = "HowWeDoIt-module--circle--2xXzq";